import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import classNames from "classnames";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";

import InformationDialog from "./InformationDialog";
import RequestAccessForm from "./RequestAccessForm";
import MessageDialog from "./MessageDialog";
import TilesData from "../../../assets/json/tiles_data.json";
import TilesDev from "../../../assets/json/tiles_data_dev.json";
import customerDetailsStyles from "assets/jss/material-kit-pro-react/views/cspDashboard/customerDetailsStyles.js";
import styles from "assets/jss/material-kit-pro-react/views/ecommerceSections/blogStyle.js";

const useStyles2 = makeStyles(styles);
const useStylesCustomerDetailsStyles = makeStyles(customerDetailsStyles);

export default function DashboardLoggedIn() {
	const classes2 = useStyles2();
	const classesCSStyles = useStylesCustomerDetailsStyles();
	const [messageData, setMessageData] = React.useState(null);
	const [requestService, setRequestService] = React.useState("");
	const [showMessageDialog, setShowMessageDialog] = React.useState(false);
	const DialogData =
		process.env.REACT_APP_ENV === "development" ? TilesDev : TilesData;

	const [selectedDialogData, setSelectedDialogData] = React.useState(
		DialogData[0]
	);
	const [informationDialogShow, setInformationDialogShow] = React.useState(
		false
	);

	const [requestAccessShow, setRequestAccessShow] = React.useState(false);

	const selectDetails = (heading) => {
		const selectedData = DialogData.find((data) => data.Heading === heading);
		setSelectedDialogData(selectedData);
		setInformationDialogShow(true);
	};

	return (
		<div className={classes2.container}>
			<GridContainer>
				{DialogData.map((data, index) => (
					<GridItem md={2} sm={2} key={index}>
						<Card className={classes2.card}>
							<CardHeader
								className={classNames(classes2.headerImage)}
								style={{
									cursor: "pointer",
									shadow: "0 2px 4px 2px rgba(0, 0, 0, 0.2) !important",
									boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.2) !important",
								}}>
								<img src={data.imageUrl} alt="..." />
							</CardHeader>
							<CardBody>
								<h6 className={classNames(classesCSStyles?.tilesTitle)}>
									{data.Heading}
								</h6>
								<p className={classNames(classesCSStyles.tilesDescription)}>
									{data.Subtext}
								</p>
								<div
									className={classNames(classesCSStyles.learnMore, "flex")}
									onClick={() => selectDetails(data.Heading)}>
									Learn More
									<div className={classesCSStyles.learnMoreIcon}>
										<i className="fas fa-angle-right" />
									</div>
								</div>
							</CardBody>
						</Card>
					</GridItem>
				))}
			</GridContainer>
			{informationDialogShow && (
				<InformationDialog
					requestService={requestService}
					setRequestService={setRequestService}
					selectedDialogData={selectedDialogData}
					setSelectedDialogData={setSelectedDialogData}
					informationDialogShow={informationDialogShow}
					setInformationDialogShow={setInformationDialogShow}
					requestAccessShow={requestAccessShow}
					setRequestAccessShow={setRequestAccessShow}
				/>
			)}
			{requestAccessShow && (
				<RequestAccessForm
					requestService={requestService}
					setRequestService={setRequestService}
					requestAccessShow={requestAccessShow}
					setRequestAccessShow={setRequestAccessShow}
					messageData={messageData}
					setMessageData={setMessageData}
					showMessageDialog={showMessageDialog}
					setShowMessageDialog={setShowMessageDialog}
				/>
			)}
			{showMessageDialog && (
				<MessageDialog
					showMessageDialog={showMessageDialog}
					setShowMessageDialog={setShowMessageDialog}
					messageData={messageData}
					setMessageData={setMessageData}
				/>
			)}
		</div>
	);
}
